import { useEffect } from 'react';

interface UseServiceCategoriesEffectsProps {
  getClientServiceCategoriesHandler: () => Promise<void>;
}
export const useServiceCategoriesEffects = ({
  getClientServiceCategoriesHandler,
}: UseServiceCategoriesEffectsProps) => {
  useEffect(() => {
    getClientServiceCategoriesHandler();
  }, [getClientServiceCategoriesHandler]);
};
